module.exports = __webpack_public_path__ + "img/gif.cb8fde98.png";